<div *ngIf="isFacilityConfigured">
  <div class="container mt-5 mb-5 pt-5">
    <div class="row">
      <div class="col-md-12">
        <div class="search-section">
          <h1>{{resourceKeyValue.clinicianSearchTitle}}</h1>
          <p>{{resourceKeyValue.clinicianSearchTitle1}}</p>
          <div class="input-group mb-2 tertiary-search w-100">
            <div class="has-clear w-100">
              <input type="text" name="search" [(ngModel)]="searchPatientDeviceValue" class="form-control"
                     placeholder="{{this.resourceKeyValue.clinicianSearchPlaceHolder}}" id="searchPatientDevice" ngxBarCodePut
                     [debounce]="100" autocomplete="off" (onDetected)="onDetected($event)" (onDelete)="onDelete($event)"
                     (keypress)="onKeypressEvent($event)" appautofocus>

              <button *ngIf="isResetButtonEnabled" class="clear-data" type="reset" (click)="resetSearchText();">
                <i class="icon-close-bold-sm"></i>
              </button>
            </div>
            <span class="input-group-append">
              <a class="ui-link serachIcon" (click)="searchPatientDevice();">
                <div class="input-group-text btn-tertiary-search border-0"><i class="icon-search-bold"></i></div>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Validation error popup -->
<ng-template #clinicalcontent let-c="close" let-d="dismiss">
  <div class="error-left">
    <i class="icon-alert-bold"></i> {{resourceKeyValue.clinicianModalTitle}}
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <p>{{modalBodyMessage}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer modal-footer-btns">
    <button type="button" class="btn btn-primary ml-4" (click)="closeModal();">{{resourceKeyValue.ok}}</button>
  </div>
</ng-template>

<!--Manual Entry form popup-->
<ng-template #manualEntryContent let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="manualBarcodePopup">{{resourceKeyValue.clinicianModalBarCodePopupTitle}}</h3>
    <button type="button" tabindex="0" class="close tabfocusable" (click)="closeManualModal();" aria-label="Close">
      <i id="" class="icon-close-bold-sm"></i>
    </button>
  </div>
  <form [formGroup]="manualEntryForm" (ngSubmit)="submitManualEntryForm()">
    <div class="modal-body">
      <div class="form-check pt-3" *ngFor="let manualEntry of manualEntryReasonList">
        <input class="form-check-input" type="radio"
               value="{{manualEntry.value}}"
               formControlName="manualEntryReason"
               id="{{manualEntry.label}}"
               (change)="changeManualReason(manualEntry); ">

        <label class="form-check-label" for="{{manualEntry.label}}">{{manualEntry.label}}</label>
      </div>

      <div class="form-group pt-2">
        <textarea *ngIf="isCommentsBoxEnabled" rows="3" placeholder="Enter comments"
                  class="form-control" maxlength="250"
                  (keyup)="onCommentsKeyup(this.otherComments)"
                  [(ngModel)]="otherComments"
                  [ngClass]="{'is-invalid': this.otherComments == ''}"
                  formControlName="othercomments" aria-multiline="true"
                  aria-describedby="textarea">
        </textarea>
      </div>
    </div>
    <div class="modal-footer modal-footer-btns">
      <button type="button" class="btn btn-secondary" (click)="closeManualModal()">{{resourceKeyValue.cancel}}</button>
      <button type="submit" class="btn btn-primary ml-4" [disabled]="isManualOkButtonDisabled">
        {{resourceKeyValue.ok}}
      </button>
    </div>
  </form>
</ng-template>

<!--Change/Keep association modal-->
<ng-template #changeKeepAssociationContent let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="changeAssociationPopup">{{resourceKeyValue.changeAssociation}}</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <p>{{modalBodyMessage}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" tabindex="-1" class="btn btn-secondary" (click)="closeModal();">{{resourceKeyValue.keepAssociation}}</button>
    <button type="button" class="btn btn-primary ml-4" (click)="changeAssociation();">{{resourceKeyValue.changeAssociation}}</button>
  </div>
</ng-template>

<!--Patient Therapy modal-->
<ng-template #patientTherapyContent let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="patientTherapyModal">{{resourceKeyValue.patientTherapyTitle}}</h3>
  </div>
  <form [formGroup]="patientTherapyForm" (ngSubmit)="submitPatientTherapyForm()">
    <div class="modal-body">
      <div class="form-check pt-3">
        <input class="form-check-input" id="newTherapySession" value="{{patientTherapy.NewTherapySession}}" type="radio" formControlName="patientTherapyName" />
        <label class="form-check-label" for="newTherapySession">{{resourceKeyValue.newTherapySessionText}}</label>
      </div>
      <div class="form-check pt-3">
        <input class="form-check-input" id="continuationTherapy" value="{{patientTherapy.ContinuationOfTherapy}}" type="radio" formControlName="patientTherapyName" />
        <label class="form-check-label" for="continuationTherapy">{{resourceKeyValue.continuationofTherapyText}}</label>
      </div>
    </div>
    <div class="modal-footer modal-footer-btns">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">{{resourceKeyValue.cancel}}</button>
      <button type="submit" class="btn btn-primary ml-4" [disabled]="!patientTherapyForm.valid">
        {{this.resourceKeyValue.ok}}
      </button>
    </div>
  </form>
</ng-template>

<!--Device creation modal-->
<ng-template #deviceCreationModal let-modal>
  <div class="modal-header">
    <h3 class="modal-title" id="deviceCreationPopup">{{resourceKeyValue.clinicianDeviceCreationPopup}}</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <p>{{modalBodyMessage}}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" tabindex="-1" class="btn btn-secondary" (click)="closeModal();">{{resourceKeyValue.cancel}}</button>
    <button type="button" class="btn btn-primary ml-4" (click)="createDevice();">{{resourceKeyValue.ok}}</button>
  </div>
</ng-template>

<div *ngIf="!isFacilityConfigured && !isLoading" class=" container-fluid mt-5 pt-5">
  <div class="row">
    <div class="col">
      <h1 id="notAuthorizedInstruction1-Label">{{lblNotAuthorizedInstruction3}}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h3 id="notAuthorizedInstruction2-Label">{{lblNotAuthorizedInstruction4}}</h3>
    </div>
  </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>
